/**
 * Location.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {

  // tableName: 'ubicaciones',

  attributes: {

    //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
    //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
    //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

    name: {
      type: 'string',
      required: true,
      // columnName: 'nombre'
    },

    customer: {
      model: 'customer',
      required: true
      // columnName: 'cliente_id'
    },

    lat: {
      type: 'number',
      required: true,
      // columnName: 'latitud'
    },

    lng: {
      type: 'number',
      required: true,
      // columnName: 'longitud'
    },

    address: {
      type: 'string',
      required: true,
      // columnName: 'domicilio'
    },

    locality: {
      type: 'string',
    },

    suburb: {
      type: 'string',
    },

    zipCode: {
      type: 'string',
    },

    municipality: {
      type: 'string',
    },

    street: {
      type: 'string',
    },

    exteriorNumber: {
      type: 'string',
    },

    interiorNumber: {
      type: 'string',
    },

    customerTaxIdRegistrationNumber: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
    },

    customerTaxResidence: {
      type: 'string',
      columnType: 'text',
      allowNull: true,
    },


    //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
    //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
    //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


    //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
    //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
    //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    originDispatches: {
      collection: 'dispatch',
      via: 'origin'
    },

    destinationDispatches: {
      collection: 'dispatch',
      via: 'destination'
    },

  },

}




// WEBPACK FOOTER //
// ./src/models/Location.js